import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import NotificationSettings from './NotificationSettings';

const NotificationButton = ({ onClick }) => {
  const [hasUnread, setHasUnread] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  // Load notification preferences
  useEffect(() => {
    try {
      const preferences = localStorage.getItem('mainbet_toast_preferences');
      if (preferences) {
        const parsed = JSON.parse(preferences);
        setNotificationsEnabled(parsed.enabled !== false);
      }
    } catch (error) {
      console.warn('Failed to load notification preferences:', error);
    }
  }, []);

  // Simulate checking for new notifications (placeholder for future implementation)
  useEffect(() => {
    // TODO: Connect to real notification system
    const checkInterval = setInterval(() => {
      // This would check for new matches, odds changes, etc.
      // For now, randomly show unread status
      setHasUnread(Math.random() > 0.7);
    }, 30000); // Check every 30 seconds

    return () => clearInterval(checkInterval);
  }, []);

  const handleButtonClick = () => {
    setIsSettingsOpen(true);
    if (onClick) onClick();
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleButtonClick}
        className="p-2 rounded-full bg-secondary-light dark:bg-dark-light relative"
        aria-label="Notifications"
      >
      {/* Bell Icon */}
      <svg 
        className={`w-5 h-5 transition-colors ${
          notificationsEnabled 
            ? 'text-gray-600 dark:text-gray-300' 
            : 'text-gray-400 dark:text-gray-500'
        }`}
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        {notificationsEnabled ? (
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
          />
        ) : (
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M5.586 15H4l1.405-1.405A2.032 2.032 0 006 12.158V11a6.002 6.002 0 014-5.659V5a2 2 0 014 0v.341C16.67 6.165 18 8.388 18 11v1.159c0 .538.214 1.055.595 1.436L20 15h-1.586m-4.707-4.707L20 4m0 0l-6.293 6.293" 
          />
        )}
      </svg>

      {/* Unread Indicator */}
      {hasUnread && notificationsEnabled && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"
        >
          {/* Pulse animation for attention */}
          <motion.div
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-full h-full bg-red-500 rounded-full"
          />
        </motion.div>
      )}

      {/* Disabled Indicator */}
      {!notificationsEnabled && (
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-gray-400 rounded-full" />
      )}
    </motion.button>

    {/* Notification Settings Modal */}
    <NotificationSettings 
      isOpen={isSettingsOpen}
      onClose={() => setIsSettingsOpen(false)}
    />
  </>
  );
};

export default NotificationButton; 